import { useEventStore } from "./event"
import { useTemplateStore } from "./template"

export const useDebugStore = defineStore('debug', () => {
  
  const isDebug = ref(false)

  const showUi = ref(false)


  const toggleShowUi = () => {
    showUi.value = !showUi.value
  }

  const data = reactive({
    startAt: null,
    eventId: null,
    sessionId: null,
    isLiff : false,
    myImageUrl: null,
    myImageRemovebgUrl: null,
    template1: { 
        templateId: null,
        bgImageUrl: null,
    },
    template2: { 
        templateId: null,
        bgImageUrl: null,
    },
    template3: { 
        templateId: null,
        bgImageUrl: null,
    },
  })
  

  const main = () => {

    // isDebug.value = true
    // showUi.value = true


    data.startAt = new Date().toLocaleString()
    data.eventId = useEventStore().eventData.eventId
     
  }
  
  
  return {
    isDebug,
    showUi,
    data,
    toggleShowUi,
    main,
  }
})

